import React, { FC } from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { Button } from '@/atoms/Button'
import { useAngelPlayerContext } from '@/organisms/AngelPlayer'
import { Episode } from '@/services/ProjectsService'
import { useSafeTrack } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'

interface SkipIntroProps {
  episode: Episode
  className?: string
  isAdPlaying: boolean
}

export const SkipIntro: FC<SkipIntroProps> = React.memo(({ className = '', episode, isAdPlaying }) => {
  const track = useSafeTrack()
  const { onSkip, inIntro, playing } = useAngelPlayerContext()
  const { t } = useTranslate('watch')

  const onHandleSkip = () => {
    onSkip()
    track('Skipped Intro', {
      guid: episode?.guid,
    })
  }

  const variants = {
    open: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        bounce: 0.2,
        duration: 0.6,
      },
    },
    closed: { y: 40, opacity: 0, display: 'none' },
  }

  const showSkip = Boolean(inIntro && playing && !isAdPlaying)

  return (
    <div
      className={classNames(
        'text-[10px] sm:text-base absolute right-6 top-6 sm:top-auto z-40 bottom-auto sm:bottom-24',
        className,
      )}
      id="skip-intro"
    >
      <motion.div animate={showSkip ? 'open' : 'closed'} variants={variants}>
        <Button onClick={onHandleSkip} variant="oxide-bright">
          {t('skipIntro', 'Skip Intro')}
        </Button>
      </motion.div>
    </div>
  )
})

SkipIntro.displayName = 'React.memo(SkipIntro)'
